import { Link } from 'react-router-dom';
import { Icon, V2Badge } from '@sakhtar/design-system/react';
import type { AiScopeItem } from '../aiPreview.js';

export interface ChatHeaderProps {
  readonly title: string;
  readonly scope: readonly AiScopeItem[];
  /** Link to the assistant settings (tenant admins only); omitted otherwise. */
  readonly settingsHref?: string | undefined;
  /** Standing state of the conversation, e.g. «موجودی صفر» (frame I). */
  readonly statusBadge?: string | undefined;
  /**
   * Mobile (frames M2 / M4): «بازگشت» to the conversation list and the button
   * that opens the context bottom sheet. Both buttons are always in the DOM and
   * are shown by the mobile media query only (display:none on desktop).
   */
  readonly onBack?: (() => void) | undefined;
  readonly onOpenContext?: (() => void) | undefined;
  readonly contextOpen?: boolean | undefined;
}

/**
 * Chat column header: conversation title, settings entry and the REAL data
 * scope — brand badge for a module the caller may read, neutral
 * «<module> — بدون دسترسی» for one they may not.
 */
export function ChatHeader({
  title,
  settingsHref,
  statusBadge,
  onBack,
  onOpenContext,
  contextOpen = false,
}: ChatHeaderProps) {
  return (
    <div className="ai-chat__header">
      {onBack ? (
        <button
          type="button"
          className="sk-btn sk-btn--ghost sk-btn--icon ai-chat__nav-btn ai-chat__back"
          aria-label="تاریخچه گفتگوها"
          onClick={onBack}
        >
          <Icon name="menu" size="md" />
        </button>
      ) : null}
      <div className="ai-chat__title">
        <span className="ai-chat__title-text">{title}</span>
        {settingsHref ? (
          <Link
            to={settingsHref}
            className="sk-btn sk-btn--ghost sk-btn--icon sk-btn--sm"
            title="تنظیمات دستیار"
            aria-label="تنظیمات دستیار"
          >
            <Icon name="settings" size="sm" />
          </Link>
        ) : null}
        {statusBadge ? <V2Badge tone="danger">{statusBadge}</V2Badge> : null}
      </div>
      {onOpenContext ? (
        <button
          type="button"
          className="sk-btn sk-btn--ghost sk-btn--icon ai-chat__nav-btn ai-chat__context-btn"
          aria-label="پنل زمینه"
          aria-haspopup="dialog"
          aria-expanded={contextOpen}
          onClick={onOpenContext}
        >
          <Icon name="layers" size="md" />
        </button>
      ) : null}
    </div>
  );
}
